
import React from 'react';
import propTypes from 'prop-types';
import './index.css';
import * as navigator from '../../native/navigator';


export default class Header extends React.Component{
  static propTypes = {
    title: propTypes.string,
    leftBtnType: propTypes.oneOf(['close','arrow','text']),
    leftText: propTypes.string, // leftBtnType是text的必须传入lefttext
    handleLeftButtonClick: propTypes.func, // 如果需要覆盖
    rightBtnType: propTypes.oneOf(['search','text','dot']),
    rightText: propTypes.string,
    handleRightBtnClick: propTypes.func,
  }


  render(){
    let {leftBtnType} = this.props;
    return(
      <div className="title-wrap">
        <div className="click-area left-wrap" onClick={this.goBack}>
          <i className={`icon icon-${leftBtnType || 'arrow'}`}></i>
        </div>
        {
          this.renderCenterContent()
        }
        {
          this.renderRightBtnContent()
        }
      </div>
    );
  }

  renderCenterContent(){
    let { title, children} = this.props;
    if(!children && title && typeof title === 'string'){
      return <h2>{title}</h2>;
    }else{
      return <div className="center-wrap">{children}</div>;
    }
  }

  renderRightBtnContent(){
    let {rightBtnType, handleRightBtnClick} = this.props;
    switch(rightBtnType){
      case 'search':
        return <SearchButton handleRightBtnClick={handleRightBtnClick}/>;
      case 'text':
        return <TextButton handleRightBtnClick={handleRightBtnClick} rightText={this.props.rightText}/>;
      case 'dot':
        return null;
        // return (
        //         <div className="click-area right-wrap" onClick={handleRightBtnClick}>
        //           <i className="icon icon-dot"></i>
        //         </div>
        // )
      default:
        return null;
    }

  }

  /**
   * 允许覆盖返回事件
   */
  goBack = ()=>{
    let {handleLeftButtonClick, backStep} = this.props;
    if(handleLeftButtonClick && typeof handleLeftButtonClick === 'function'){
      handleLeftButtonClick();
    }else{
      navigator.back(backStep || 1);
    }
  }

}


function SearchButton(props){
  return(
    <div className="click-area right-wrap" onClick={props.handleRightBtnClick}>
      <i className="icon icon-search"></i>
    </div>
  );
}


function TextButton(props){
  return(
    <div className="click-area right-wrap" onClick={props.handleRightBtnClick}>
      {props.rightText}
    </div>
  );
}


navigator.removeBackButton();


// WEBPACK FOOTER //
// ./src/components/Header/index.js